import { useFiltersContext } from '@openx/components-filters/lib/context/FiltersContext.tsx';
import { TopBar } from '@openx/components-table/ChipFilters/TopBar.tsx';
import { useTranslation } from 'react-i18next';
import type { DirectDealsListFilters } from '../../types.ts';

export const DirectDealsTopBar = () => {
  const { t } = useTranslation();
  const { onFiltersChange, criteria } = useFiltersContext<DirectDealsListFilters>();

  return (
    <TopBar
      filters={criteria.filters as DirectDealsListFilters}
      onChange={onFiltersChange}
      searchText={t('Search Name')}
      useFiltersV2
    />
  );
};
